export default "__VITE_ASSET__BUpfkTGO__"